<template>
  <Guide :titleList="titleList">
    <template #innerContent>
      <div style="width: 100%;height: 50px;margin-top: 30px">
      </div>
      <h1>{{ $t('guide.home.title') }}</h1>
      <div>{{ $t('guide.home.des') }}</div>
      <br>
      <div>{{ $t('guide.home.message') }}</div>
      <div id="part1" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.1')" :level="1" v-model:visible="collapseState.isShow1">
          <div id="part_child_1_1">
            <CollapseItem :title="$t('guide.home.part.1.1')" :level="2" v-model:visible="collapseState.isShow1_1">
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.1') }}<span
                  class="w700">{{ $t('guide.part.1.txt.2') }}</span>{{ $t('guide.part.1.txt.3') }}<span
                  class="w700">{{ $t('guide.part.1.txt.4') }}</span></div>
              <br>
              <ImageShow :url="homeGuideImages.docImg1" :priority="true" :prefer-original="true" root-margin="0px"/>
              <br>
              <div>{{ $t('guide.part.1.txt.5') }}</div>
              <br>
              <div>{{ $t('guide.part.1.txt.6') }}</div>
              <br>
              <div>
                {{ $t('guide.part.1.txt.7') }}
              </div>
              <br>
              <div>
                <span class="w700 red">{{ $t('guide.part.tip') }}</span>{{ $t('guide.part.1.txt.8') }}
              </div>
              <br>
              <br>
              <div class="step w700">{{ $t('guide.part.1.txt.9') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.10') }}<span
                  class="w700">{{ $t('guide.part.1.txt.11') }}</span>{{ $t('guide.part.1.txt.12') }}
              </div>
              <br>
              <div>{{ $t('guide.part.1.txt.13') }}<span
                  class="w700">{{ $t('guide.part.1.txt.14') }}</span>{{ $t('guide.part.1.txt.15') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg2" :priority="true" :prefer-original="true" root-margin="80px 0px"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg3"/>
              <br>
              <div>{{ $t("guide.part.1.txt.16") }}<span
                  class="w700">{{ $t('guide.part.1.txt.17') }}</span>{{ $t('guide.part.1.txt.18') }}
              </div>
              <br>
              <div>
                {{ $t('guide.part.1.txt.13') }}<span
                  class="w700">{{ $t('guide.part.1.txt.19') }}</span>{{ $t('guide.part.1.txt.20') }}<span class="w700">{{
                  $t('guide.part.1.txt.21')
                }}</span>{{ $t('guide.part.1.txt.22') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg4"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg5"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.tip') }}</span>{{ $t('guide.part.1.txt.23') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg6"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg7"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.tip') }}</span>{{ $t('guide.part.1.txt.24') }}
              </div>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_1_2">
            <CollapseItem :title="$t('guide.home.part.1.2')" :level="2" v-model:visible="collapseState.isShow1_2">
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.25') }}</div>
              <br>
              <br>
              <div><span class="w700">{{ $t('guide.part.1.txt.26') }}</span>{{ $t('guide.part.1.txt.27') }}</div>
              <br>
              <ImageShow :url="homeGuideImages.docImg8"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.28') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.29') }}<span
                  class="w700">{{ $t('guide.part.1.txt.30') }}</span>{{ $t('guide.part.1.txt.31') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg9"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.32') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.33') }}</div>
              <br>
              <ImageShow :url="homeGuideImages.docImg10"/>
              <br>
              <div class="red">{{ $t('guide.part.1.txt.34') }}</div>
            </CollapseItem>
          </div>
          <div id="part_child_1_3">
            <CollapseItem :title="$t('guide.home.part.1.3')" :level="2" v-model:visible="collapseState.isShow1_3">
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.35') }}</div>
              <br>
              <br>
              <div><span class="w700">{{ $t('guide.part.1.txt.36') }}</span>{{ $t('guide.part.1.txt.37') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg11"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.38') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.39') }}<span
                  class="w700">{{ $t('guide.part.1.txt.17') }}</span>{{ $t('guide.part.1.txt.40') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg12"/>
              <br>
              <div>{{ $t('guide.part.1.txt.41') }}</div>
              <br>
              <DeferredVideoPlayer
                  :poster="homeGuideImages.docImg12"
                  :src="() => require('@/assets/video/10431_1758004157.mp4')"
              />
            </CollapseItem>
          </div>
          <div id="part_child_1_4">
            <CollapseItem :title="$t('guide.home.part.1.4')" :level="2" v-model:visible="collapseState.isShow1_4">
              <br>
              <div>{{ $t('guide.part.1.txt.42') }}</div>
              <br>
              <div>
                {{ $t('guide.part.1.txt.43') }}
              </div>
              <br>
              <div>{{ $t('guide.part.1.txt.44') }}</div>
              <br>
              <ImageShow :url="homeGuideImages.docImg13"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.45') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.46') }}</div>
              <br>
              <ImageShow :url="homeGuideImages.docImg14"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg15"/>
              <br>
              <div>{{ $t('guide.part.1.txt.47') }}</div>
              <br>
              <ImageShow :url="homeGuideImages.docImg16"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg17"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg18"/>
              <br>
              <div>{{ $t('guide.part.1.txt.48') }}<span
                  class="w700">{{ $t('guide.part.1.txt.49') }}</span>{{ $t('guide.part.1.txt.50') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg19"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.51') }}</div>
              <br>
              <br>
              <div><span class="w700">{{ $t('guide.part.1.txt.52') }}</span>{{ $t('guide.part.1.txt.53') }}</div>
              <br>
              <ImageShow :url="homeGuideImages.docImg20"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.54') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.55') }}</div>
              <br>
              <div>{{ $t('guide.part.1.txt.56') }}</div>
              <br>
              <ImageShow :url="homeGuideImages.docImg21"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg22"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg23"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg24"/>
              <br>
              <div>{{ $t('guide.part.1.txt.57') }}</div>
              <br>
              <DeferredVideoPlayer
                  :poster="homeGuideImages.docImg24"
                  :src="() => require('@/assets/video/10433_1758004177.mp4')"
              />
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.58') }}</div>
              <br>
              <div>
                {{ $t('guide.part.1.txt.59') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg25"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg26"/>
              <br>
              <br>
              <br>
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part2" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.2')" :level="1" v-model:visible="collapseState.isShow2">
          <div id="part_child_2_1">
            <CollapseItem :title="$t('guide.home.part.2.1')" :level="2" v-model:visible="collapseState.isShow2_1">
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.1') }}</div>
              <br>
              <br>
              <div class="w700">{{ $t('guide.part.2.txt.2') }}</div>
              <br>
              <ImageShow :url="homeGuideImages.docImg27"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.3') }}</div>
              <br>
              <br>
              <div>
                {{ $t('guide.part.2.txt.4') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg28"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.5') }}</span>{{ $t('guide.part.2.txt.6') }}
              </div>
              <br>
              <div>{{ $t('guide.part.2.txt.7') }}</div>
              <ImageShow :url="homeGuideImages.docImg29"/>
              <div>{{ $t('guide.part.2.txt.8') }}</div>
              <ImageShow :url="homeGuideImages.docImg30"/>
              <div>{{ $t('guide.part.2.txt.9') }}</div>
              <ImageShow :url="homeGuideImages.docImg31"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.10') }}</span><span
                  class="w700">{{ $t('guide.part.2.txt.11') }}</span>{{ $t('guide.part.2.txt.12') }}<span class="w700">{{
                  $t('guide.part.2.txt.13')
                }}</span>{{ $t('guide.part.2.txt.14') }}<span
                  class="w700">{{ $t('guide.text.email.text.17') }}</span>{{ $t('guide.part.2.txt.15') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg32"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg33"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.16') }}</span>{{ $t('guide.part.2.txt.17') }}<span
                  class="w700">{{ $t('guide.part.2.txt.18') }}</span>{{ $t('guide.part.2.txt.19') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg34"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg35"/>
              <br>
              <div>{{ $t('guide.part.2.txt.20') }}<span
                  class="w700">{{ $t('guide.part.2.txt.21') }}</span>{{ $t('guide.part.2.txt.22') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg36"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.23') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.2.txt.24') }}<span
                  class="w700">{{ $t('guide.part.2.txt.25') }}</span>{{ $t('guide.part.2.txt.26') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg37"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.27') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.2.txt.28') }}</div>
              <br>
              <div>{{ $t('guide.part.2.txt.29') }}</div>
              <br>
              <ImageShow :url="homeGuideImages.docImg38"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg39"/>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.30') }}</span>{{ $t('guide.part.2.txt.31') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg40"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_2_2">
            <CollapseItem :title="$t('guide.home.part.2.2')" :level="2" v-model:visible="collapseState.isShow2_2">
              <br>
              <div>{{ $t('guide.part.2.txt.32') }}<span
                  class="w700">{{ $t('guide.part.2.txt.33') }}</span>{{ $t('guide.part.2.txt.34') }}
              </div>
              <br>
              <div>{{ $t('guide.part.2.txt.35') }}<span
                  class="w700">{{ $t("guide.part.2.txt.36") }}</span>{{ $t("guide.part.2.txt.37") }}<span
                  class="w700">{{ $t('guide.part.2.txt.38') }}</span>{{ $t('guide.part.2.txt.39') }}<span class="w700">{{
                  $t('guide.part.2.txt.40')
                }}</span>
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg41"/>
              <br>
              <div><span class="red w700">{{ $t('guide.part.2.txt.5') }}</span>{{ $t('guide.part.2.txt.41') }}
              </div>
              <br>
              <div><span class="red w700">{{ $t('guide.part.2.txt.10') }}</span>{{ $t('guide.part.2.txt.42') }}
              </div>
              <br>
              <div><span class="red w700">{{ $t('guide.part.2.txt.16') }}</span>{{ $t('guide.part.2.txt.43') }}
              </div>
              <br>
              <div><span class="red w700">{{ $t('guide.part.2.txt.44') }}</span>{{ $t('guide.part.2.txt.45') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg42"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_2_3">
            <CollapseItem :title="$t('guide.home.part.2.3')" :level="2" v-model:visible="collapseState.isShow2_3">
              <br>
              <div>{{ $t('guide.part.2.txt.46') }}<span
                  class="w700">{{ $t('guide.part.2.txt.47') }}</span>{{ $t('guide.part.2.txt.48') }}<span
                  class="w700">{{ $t('guide.part.2.txt.49') }}</span>{{ $t('guide.part.2.txt.50') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg43"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg44"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.51') }}</div>
              <br>
              <br>
              <ImageShow :url="homeGuideImages.docImg45"/>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.52') }}</span>{{ $t('guide.part.2.txt.53') }}</div>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.54') }}</span>{{ $t('guide.part.2.txt.55') }}<span
                  class="w700">{{ $t('guide.part.2.txt.56') }}</span>{{ $t('guide.part.2.txt.57') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg46"/>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.58') }}</span>{{ $t('guide.part.2.txt.59') }}</div>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.60') }}</span>{{ $t('guide.part.2.txt.61') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg47"/>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.62') }}</span>{{ $t('guide.part.2.txt.63') }}
              </div>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.64') }}</span>{{ $t('guide.part.2.txt.65') }}<span
                  class="w700">{{ $t('guide.part.2.txt.66') }}</span>{{ $t('guide.part.2.txt.67') }}
              </div>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.68') }}</span>{{ $t('guide.part.2.txt.69') }}<span
                  class="w700">{{ $t("guide.part.2.txt.70") }}</span>{{ $t('guide.part.2.txt.71') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg48"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg49"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.72') }}</div>
              <br>
              <br>
              <ImageShow :url="homeGuideImages.docImg50"/>
              <br>
              <div>{{ $t('guide.part.2.txt.73') }}<span
                  class="w700">{{ $t('guide.part.2.txt.74') }}</span>{{ $t('guide.part.2.txt.75') }}
              </div>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.76') }}</div>
              <br>
              <br>
              <ImageShow :url="homeGuideImages.docImg51"/>
              <br>
              <div>{{ $t('guide.part.2.txt.77') }}<span
                  class="w700">{{ $t('guide.part.2.txt.78') }}</span>{{ $t('guide.part.2.txt.79') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg52"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg53"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg54"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg55"/>
              <br>
              <ImageShow :url="homeGuideImages.docImg56"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.80') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.2.txt.81') }}</div>
              <br>
              <div>{{ $t("guide.part.2.txt.82") }}<span
                  class="w700">{{ $t('guide.part.2.txt.83') }}</span>{{ $t('guide.part.2.txt.84') }}
              </div>
              <br>
              <ImageShow :url="homeGuideImages.docImg57"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_2_4">
            <CollapseItem :title="$t('guide.home.part.2.4')" :level="2" v-model:visible="collapseState.isShow2_4">
              <HomeGuideBlockRenderer
                :blocks="homeGuidePartTwoTailSections[0].blocks"
                :image-map="homeGuideImages"
                :leading-breaks="homeGuidePartTwoTailSections[0].leadingBreaks"
                :trailing-breaks="homeGuidePartTwoTailSections[0].trailingBreaks"
              />
            </CollapseItem>
          </div>
          <div id="part_child_2_5">
            <CollapseItem :title="$t('guide.home.part.2.5')" :level="2" v-model:visible="collapseState.isShow2_5">
              <HomeGuideBlockRenderer
                :blocks="homeGuidePartTwoTailSections[1].blocks"
                :image-map="homeGuideImages"
                :leading-breaks="homeGuidePartTwoTailSections[1].leadingBreaks"
                :trailing-breaks="homeGuidePartTwoTailSections[1].trailingBreaks"
              />
            </CollapseItem>
          </div>
          <div id="part_child_2_6">
            <CollapseItem :title="$t('guide.home.part.2.6')" :level="2" v-model:visible="collapseState.isShow2_6">
              <HomeGuideBlockRenderer
                :blocks="homeGuidePartTwoTailSections[2].blocks"
                :image-map="homeGuideImages"
                :leading-breaks="homeGuidePartTwoTailSections[2].leadingBreaks"
                :trailing-breaks="homeGuidePartTwoTailSections[2].trailingBreaks"
              />
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part3" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.3')" :level="1" v-model:visible="collapseState.isShow3">
          <br>
          <div>{{ $t('g.p3.t.1') }}</div>
          <br>
          <div id="part_child_3_1">
            <CollapseItem :title="$t('guide.home.part.3.1')" :level="2" v-model:visible="collapseState.isShow3_1">
              <HomeGuideBlockRenderer
                :blocks="homeGuidePartThreeHeadSections[0].blocks"
                :image-map="homeGuideImages"
                :leading-breaks="homeGuidePartThreeHeadSections[0].leadingBreaks"
                :trailing-breaks="homeGuidePartThreeHeadSections[0].trailingBreaks"
              />
            </CollapseItem>
          </div>
          <div id="part_child_3_2">
            <CollapseItem :title="$t('guide.home.part.3.2')" :level="2" v-model:visible="collapseState.isShow3_2">
              <HomeGuideBlockRenderer
                :blocks="homeGuidePartThreeHeadSections[1].blocks"
                :image-map="homeGuideImages"
                :leading-breaks="homeGuidePartThreeHeadSections[1].leadingBreaks"
                :trailing-breaks="homeGuidePartThreeHeadSections[1].trailingBreaks"
              />
            </CollapseItem>
          </div>
          <div
            v-for="section in homeGuidePartThreeTailSections"
            :id="section.id"
            :key="section.id"
          >
            <CollapseItem
              :title="$t(section.titleKey)"
              :level="2"
              v-model:visible="collapseState[section.visibleKey]"
            >
              <HomeGuideBlockRenderer
                :blocks="section.blocks"
                :image-map="homeGuideImages"
                :leading-breaks="section.leadingBreaks"
                :trailing-breaks="section.trailingBreaks"
              />
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part4" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.4')" :level="1" v-model:visible="collapseState.isShow4">
          <HomeGuideBlockRenderer
            :blocks="homeGuidePartFourIntroBlocks"
            :image-map="homeGuideImages"
            :leading-breaks="1"
            :trailing-breaks="0"
          />
          <div
            v-for="section in homeGuidePartFourSections"
            :id="section.id"
            :key="section.id"
          >
            <CollapseItem
              :title="$t(section.titleKey)"
              :level="2"
              v-model:visible="collapseState[section.visibleKey]"
            >
              <HomeGuideBlockRenderer
                :blocks="section.blocks"
                :image-map="homeGuideImages"
                :leading-breaks="section.leadingBreaks"
                :trailing-breaks="section.trailingBreaks"
              />
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part5" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.6')" :level="1" v-model:visible="collapseState.isShow6">
          <div
            v-for="section in homeGuidePartSixSections"
            :id="section.id"
            :key="section.id"
          >
            <CollapseItem
              :title="$t(section.titleKey)"
              :level="2"
              v-model:visible="collapseState[section.visibleKey]"
            >
              <HomeGuideBlockRenderer
                :blocks="section.blocks"
                :image-map="homeGuideImages"
                :leading-breaks="section.leadingBreaks"
                :trailing-breaks="section.trailingBreaks"
              />
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part6" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.5')" :level="1" v-model:visible="collapseState.isShow5">
          <HomeGuideBlockRenderer
            :blocks="homeGuideFaqBlocks"
            :image-map="homeGuideImages"
            :leading-breaks="2"
            :trailing-breaks="0"
          />
        </CollapseItem>
      </div>
    </template>
  </Guide>
</template>

<script setup>
import Guide from "@/views/FileDoc/components/Guide.vue";
import ImageShow from "@/views/FileDoc/components/ImageShow.vue";
import DeferredVideoPlayer from "@/views/FileDoc/components/DeferredVideoPlayer.vue";
import HomeGuideBlockRenderer from "@/views/FileDoc/components/HomeGuideBlockRenderer.vue";
import {computed, reactive} from "vue";
import CollapseItem from "@/views/FileDoc/components/CollapseItem.vue";
import {useI18n} from "vue-i18n";
import {homeGuideImages} from "@/views/FileDoc/components/guideImageLoaders";
import {
  createHomeGuideCollapseState,
  createHomeGuideTitleList,
  homeGuideFaqBlocks,
  homeGuidePartFourIntroBlocks,
  homeGuidePartFourSections,
  homeGuidePartThreeHeadSections,
  homeGuidePartThreeTailSections,
  homeGuidePartTwoTailSections,
  homeGuidePartSixSections,
} from "@/views/FileDoc/components/homeGuideSchema";

const {t} = useI18n()

const collapseState = reactive(createHomeGuideCollapseState())

const titleList = computed(() => createHomeGuideTitleList(t))
</script>
<style lang="less" scoped>
@import "../index";

:deep(.el-icon) {
  font-size: 16px !important;
}

.step {
  width: max-content;
  background: rgb(252, 231, 90);
}

.w700 {
  font-weight: 700;
}

.red {
  color: rgb(223, 42, 63);
}
</style>
